import { render, staticRenderFns } from "./CatchScreen.vue?vue&type=template&id=74281428&"
import script from "./CatchScreen.vue?vue&type=script&lang=js&"
export * from "./CatchScreen.vue?vue&type=script&lang=js&"
import style0 from "./CatchScreen.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CatchScreen.vue"
export default component.exports